import { LoadableUsers } from "features";
import React from "react";
import { Breadcrumb } from "shared/ui/components";

export default function UsersPage() {
  return (
    <>
      <Breadcrumb />
      <LoadableUsers />
    </>
  );
}
